import { generalHelpers } from '@tweddle-se-team/common/helpers'
import dotenv from 'dotenv'
dotenv.config()
import autoParse from 'auto-parse'

const isServer = generalHelpers.isServer()

const set = (variable, defaultValue, type) => {
  let value = autoParse(process.env[variable], type)
  if ([undefined, null].includes(value)) {
    value = defaultValue
    const usingDefault = value !== undefined ? '. Using default value' : ''
    if (isServer) console.warn(`Environment variable "${variable}" is not defined ${usingDefault}`)
  }
  return value
}

export const apiUrlSsr = set('API_URL_SSR')
export const apiUrlClient = set('API_URL_CLIENT')
export const nodeEnv = set('NODE_ENV', 'development')
export const logLevel = set('LOG_LEVEL', 'info')
export const toyotaManualsUrl = set('TOYOTA_MANUALS_URL', 'https://mytoyotamanual.eu')
export const lexusManualsUrl = set('LEXUS_MANUALS_URL', 'https://mylexusmanual.eu')

// This is a build time variable so it needs to use process.env directly
// To be in-line replaced by webpack during build
export const customerId = set('CUSTOMER_ID') || process.env.CUSTOMER_ID
